import { render, staticRenderFns } from "./Section2.vue?vue&type=template&id=a9f1b11a&scoped=true&"
import script from "./Section2.vue?vue&type=script&lang=js&"
export * from "./Section2.vue?vue&type=script&lang=js&"
import style0 from "./Section2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section2.vue?vue&type=style&index=1&id=a9f1b11a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f1b11a",
  null
  
)

export default component.exports